<template>
  <div>
    <Subheader title="Become a ChangeMaker" />

    <div class="app-content-column">
      <div class="search-card">
        <h5>
          Looking to fund your great idea?<br />
          Get started today!
        </h5>
        <div class="button-wrapper is-centered">
          <button class="large-button" @click="handleGetStarted">Get Started</button>
        </div>
      </div>

      <div class="card">
        <h5>About</h5>
        <p class="bold-text">
          Do you have a new project idea to help change your community for the better? Start here!
          (You can also share an existing project or organization that could use additional
          support.)
        </p>
      </div>

      <div class="card">
        <h5>Verification</h5>
        <p>
          All projects are verified by a third party or a project sponsor before being posted onto
          the site. Once a project is proposed, a Mzingo Partners “Activator” reviews the idea,
          contacts the “ChangeMaker”, and verifies specific details. If necessary, the Activator
          works with the ChangeMaker to prepare the project for posting.
        </p>
      </div>

      <div class="card">
        <h5>Projects</h5>
        <p>
          Mzingo Partners defines a “Project” as any specifically defined need for funding that can
          be clearly demonstrated against a practical, verifiable impact. For now, we are testing
          project ideas for $10,000 or less. We suggest breaking the project into sub-goals so that
          people are more likely to give small amounts towards those goals on a monthly basis. You
          are less likely to get a lump-sum funding gift of $10,000 than you are for a $25 monthly
          contribution towards buying school books, or materials to build something, etc. A
          “Project” can be for a person, a family, a community project, or a local organization.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Subheader from '@/components/Subheader'

import User from '@/services/users'

export default {
  name: 'MakerOnboarding',
  components: {
    Subheader,
  },
  computed: {
    ...mapGetters(['getUser']),
  },
  methods: {
    async handleGetStarted() {
      // Set user as Maker
      let user = this.getUser
      user.isMaker = true
      const response = await User.api.update(user, ['isMaker'])
      this.$store.commit('UPDATE_USER', response)

      // Inform subsequent component that this is our first project
      this.$router.push({ name: 'NewProject', params: { newMaker: true } })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';
@import '../styles/mixins/cards';
@import '../styles/mixins/buttons';
@import '../styles/layout';

.search-card {
  @include card-w-borders();
  text-align: center;
}

.card {
  @include card-w-borders();
}

.bold-text {
  font-family: $base-bold-font-family;
}
</style>
